import React, { createContext, useState, useEffect } from 'react';
import { useAppState } from '.';
import { ChatProps } from '../components/Chat';

export interface ThemeContextTypes extends ChatProps {
  setTheme(state: any): void;
}

export const ThemeContext = createContext<ThemeContextTypes>(null!);

const ThemeContextProvider: React.FC = React.memo(({ children }) => {
  const { translationBundle, getTranslation } = useAppState();
  const [theme, setTheme] = useState<ChatProps>({});

  useEffect(() => {
    if (Object.keys(translationBundle).length) {
      setTheme({
        horizontalPosition: 'right',
        header: {
          title: getTranslation('THEME_APP_TITLE'),
          icon: 'fa fa-envelope-o',
          backgroundColor: '#000',
          titleColor: '#fff'
        },
        body: {
          backgroundColor: '#f0f0f0',
          buttonsColor: '#000',
          timeDividerBackgroundColor: '#e1f5feeb',
          timeDividerTextColor: 'rgba(0, 0, 0, 0.88)',
          customer: {
            messageBackgroundColor: '#000',
            messageTextColor: '#fff',
            messageHourTextColor: '#fff',
            runnableTrackColor: '#fff',
            sliderTrackColor: '#00a5f4',
          },
          enterprise: {
            messageBackgroundColor: '#fff',
            messageTextColor: '#222d38',
            messageHourTextColor: 'rgba(0,0,0,0.45)',
            runnableTrackColor: '#f0f0f0',
            sliderTrackColor: '#00a5f4'
          }
        },
        footer: {
          textInput: {
            textColor: '#4a4a4a',
            backgroundColor: '#fff',
            placeholderColor: '#999',
            sendIconColor: '#000'
          },
          iconsPanel: {
            iconsBackgroundHoverColor: '#0000000a',
            backgroundColor: '#f1f1f1',
            iconsColor: '#6A6A6A'
          }
        }
      });
    }
  }, [translationBundle, getTranslation]);

  return (
    <ThemeContext.Provider value={{ ...theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
})


export default ThemeContextProvider;